// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-nocheck

import './_index-banner.scss';
import StickySidebar from 'sticky-sidebar/src/sticky-sidebar.js';

// Init Index component and enable better accessibility features.

export default function IndexBanner() {
    const $wrappers = document.querySelectorAll('.index-banner');
    const $bookmarks = document.querySelectorAll('.bookmark');
    const $accordions = document.querySelectorAll('.accordion');
    let isScrolling = false;

    if ($wrappers) {
        $wrappers.forEach($wrapper => {
            let currentVisibleSectionId: any;
            const $labelSelect = $wrapper.querySelector('.search-select__opener') as HTMLDivElement;
            const $customOptions = Array.from($wrapper.querySelectorAll('.option-div'));
            const $indexWrapper = $wrapper.querySelector('.index-wrapper') as HTMLDivElement;

            function handleScroll($links: any, $anchors: any) {
                $links[0]?.setAttribute('aria-selected', 'true');

                window.addEventListener('scroll', () => {
                    const scrollPosition = window.scrollY + window.innerHeight / 2;

                    let activeLink = null;

                    $anchors.forEach(anchor => {
                        const anchorTop = anchor.offsetTop;
                        const anchorHeight = anchor.offsetHeight;

                        if (scrollPosition >= anchorTop && scrollPosition < anchorTop + anchorHeight) {
                            const targetId = anchor.getAttribute('id');
                            activeLink = $wrapper.querySelector(`.options a[href="#${targetId}"]`);
                        }
                    });

                    if (activeLink) {
                        $links.forEach(link => {
                            link.parentElement.classList.remove('active');
                            link.setAttribute('aria-selected', 'false');
                        });
                        activeLink.parentElement.classList.add('active');
                        activeLink.setAttribute('aria-selected', 'true');
                    }
                });

                if (window.innerWidth > 992) {
                    $links.forEach((link: any) => {
                        link.onclick = (event) => {
                            event.preventDefault();
                            isScrolling = true;

                            const targetId = link.getAttribute('href').substring(1);
                            const targetElement = document.getElementById(targetId);

                            if (targetElement) {
                                const offsetTop = targetElement.offsetTop - 100;

                                window.scrollTo({
                                    top: offsetTop,
                                    behavior: 'smooth',
                                });

                                link.addEventListener('transitionend', () => {
                                    isScrolling = false;
                                    const activeLink = document.querySelector(`.options a[href="#${targetId}"]`);
                                    $links.forEach(link => {
                                        link.parentElement.classList.remove('active');
                                        link.setAttribute('aria-selected', 'false');
                                    });
                                    activeLink.parentElement.classList.add('active');
                                    activeLink.setAttribute('aria-selected', 'true');
                                });

                                setTimeout(() => {
                                    isScrolling = false;
                                    const activeLink = document.querySelector(`.options a[href="#${targetId}"]`);
                                    $links.forEach(link => {
                                        link.parentElement.classList.remove('active');
                                        link.setAttribute('aria-selected', 'false');
                                    });
                                    activeLink.parentElement.classList.add('active');
                                    activeLink.setAttribute('aria-selected', 'true');
                                }, 500);
                            }
                        };


                        link.addEventListener('keyup', e => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                const href = link.getAttribute('href').substring(1);
                                const targetElement = document.getElementById(href);
                                if (targetElement && targetElement.nextElementSibling.querySelector('[tabindex]')) {
                                    window.scrollTo({ top: 0, behavior: 'smooth' });
                                    (targetElement.nextElementSibling.querySelector('[tabindex]') as any).focus();
                                }
                            }
                        });
                    });
                }
            }

            function handleScrollMobile($anchors: any) {
                window.addEventListener('scroll', () => {
                    const scrollPosition = window.scrollY || document.documentElement.scrollTop;

                    $anchors.forEach(($anchor: any, index: number) => {
                        const topOffset = $anchor.getBoundingClientRect().top + scrollPosition;
                        const targetId = $anchor.getAttribute('id') as any;
                        const $options = $wrapper.querySelectorAll('option');

                        if (targetId) {
                            currentVisibleSectionId = targetId;

                            if (index === $anchors.length - 1 && topOffset <= scrollPosition + 440) {
                                $options.forEach(($option: any) => {
                                    if ($option.value === targetId) {
                                        $labelSelect.innerHTML = $option.innerHTML;

                                        $customOptions.forEach($item => {
                                            if ($item.getAttribute('option-id') === $option.value) {
                                                $customOptions.forEach($el => {
                                                    $el.classList.remove('selected');
                                                    $el.setAttribute('aria-selected', 'false');
                                                });

                                                $item.classList.add('selected');
                                                $item.setAttribute('aria-selected', 'true');
                                            }
                                        });
                                    }
                                });
                            } else if (index < $anchors.length - 1 && topOffset <= scrollPosition + 300) {
                                $options.forEach(($option: any) => {
                                    if ($option.value === targetId) {
                                        $labelSelect.innerHTML = $option.innerHTML;

                                        $customOptions.forEach($item => {
                                            if ($item.getAttribute('option-id') === $option.value) {
                                                $customOptions.forEach($el => {
                                                    $el.setAttribute('aria-selected', 'false');
                                                    $el.classList.remove('selected');
                                                });

                                                $item.setAttribute('aria-selected', 'true');
                                                $item.classList.add('selected');
                                            }
                                        });
                                    }
                                });
                            }
                        }
                    });
                });
            }

            function scrollContentMobile(element: any) {
                window.scrollTo({
                    behavior: 'smooth',
                    top: element.getBoundingClientRect().top + window.scrollY - 150,
                });
            }

            function setupContentMobile() {
                const selectElement = document.getElementById('index-select') as any;

                selectElement &&
                selectElement.addEventListener('change', function () {
                    const selectedValue = selectElement.value;
                    const selectedContent = document.getElementById(selectedValue) as any;
                    if (selectedContent) {
                        scrollContentMobile(selectedContent);
                    }
                });
            }

            setupContentMobile();

            function ui() {
                window.addEventListener('scroll', () => {
                    const $header = document.querySelector('header .content.sticky') as HTMLDivElement;
                    if ($header) {
                        $indexWrapper.style.top = `${$header.clientHeight}px`;
                    }
                });

                window.addEventListener('resize', () => {
                    if (window.innerWidth < 992) {
                        const $header = document.querySelector('header .content.sticky') as HTMLDivElement;
                        if ($header) {
                            $indexWrapper.style.top = `${$header.clientHeight}px`;
                        }
                    }
                });
            }

            function resize(_matches: any) {
                if (window.innerWidth < 992) {
                    const $anchors = $wrapper.querySelectorAll('.content [id^="index-"]');
                    handleScrollMobile($anchors);
                    ui();
                } else {
                    const $links = $wrapper.querySelectorAll('.options a');
                    const $anchors = $wrapper.querySelectorAll('.content [id^="index-"]');

                    handleScroll($links, $anchors);
                }
            }

            const mediaQuery = window.matchMedia('(max-width: 992px)');
            mediaQuery.addEventListener('change', e => resize(e.matches));

            function init() {
                let sidebar: any;

                $bookmarks &&
                $bookmarks.forEach(($bookmark, index) => {
                    ($bookmark as HTMLDivElement).nextElementSibling.setAttribute('id', `index-${index}`);
                });

                if (window.innerWidth >= 992) {
                    sidebar = new StickySidebar('.index-wrapper', {
                        containerSelector: '.index-banner',
                        innerWrapperSelector: '.index-wrapper',
                        topSpacing: 160,
                        bottomSpacing: 20,
                    });
                }

                window.addEventListener('resize', () => {
                    if (window.innerWidth < 992 && sidebar) {
                        sidebar.destroy();
                    }
                });

                if($accordions && $accordions.length) {
                    $accordions.forEach((accordion: Element) => {
                        accordion.addEventListener('click', () => {
                            if (sidebar) {
                                sidebar.updateSticky();
                            }
                        });
                    });
                }

                resize(mediaQuery.matches);
            }

            init();
        });
    }
}

